import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/termometre.actions';

import randomstring from 'uuid/v4';

import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AddIcon from '@material-ui/icons/AddCircle';
import DeleteIcon from '@material-ui/icons/Delete';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import SelectInput from '../../../inputs/SelectInput';

class AddSensor extends React.Component {
    state = {
        name: this.props.sensor ? this.props.sensor.nombre : '',
        code: this.props.sensor ? this.props.sensor.sensorCode : '',
        id: this.props.sensor ? this.props.sensor.sensorId : '',
        _field: undefined,
        _process: undefined,
        fields: this.props.sensor ? this.props.sensor.campos : [],
    };

    constructor(props) {
        super(props);
        props.getFields(props.local);
    }

    handleDelete = (field) => (event) => {
        const fields = [...this.state.fields];
        const index = fields.indexOf(field);
        fields.splice(index, 1);
        this.setState({ fields: fields });
    };

    handleChangeProces = (event) => {
        this.setState({ _process: event, _field: undefined });
    };

    handleChangeField = (event) => {
        this.setState({ _field: event });
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleClose = (name, code, id, field) => (event) => {
        if (name && code && id && field) this.props.handleClose(name, code, id, field);
        else this.props.handleClose();
    };

    handleAdd = (event) => {
        const { fields, _process, _field } = this.state;
        if (_process && _field && fields.map((f) => f.campo).indexOf(_field.value) === -1) {
            fields.push({
                campo: _field.value,
                ncampo: _field.label,
                pnombre: _process.label,
                proceso: _process.value,
            });
            this.setState({ sensor: fields });
        }
    };

    render() {
        const { name, code, id, _field, _process, fields } = this.state;
        const { intl, termometres_fields, sensor } = this.props;
        return (
            <Dialog
                fullScreen={true}
                open={true}
                onClose={this.handleClose()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="z_index_dialog_over_2dialog"
            >
                <DialogContent className={'padding_borders termometres_dialog'}>
                    <div className="flex_full_row margin_top_32 align_center">
                        <TextField
                            required
                            fullWidth
                            name={'name'}
                            id={'name'}
                            label={intl.formatMessage({ id: 'form_field_name_nombre' })}
                            defaultValue={name}
                            onChange={this.handleChange}
                        />
                    </div>
                    <div className="flex_full_row margin_top_32 align_center">
                        <TextField
                            required
                            fullWidth
                            disabled={sensor !== undefined}
                            name={'code'}
                            id={'code'}
                            label={intl.formatMessage({ id: 'form_field_name_sensorCode' })}
                            defaultValue={code}
                            onChange={this.handleChange}
                        />
                    </div>
                    <div className="flex_full_row margin_top_32 align_center">
                        <TextField
                            required
                            fullWidth
                            disabled={sensor !== undefined}
                            name={'id'}
                            id={'id'}
                            label={intl.formatMessage({ id: 'form_field_name_sensorId' })}
                            defaultValue={id}
                            onChange={this.handleChange}
                        />
                    </div>
                    <div className="flex_full_row align_center margin_top_32 margin_bottom_12">
                        <div className={'flex_full width100 barlow_italic c_slate'}>
                            <SelectInput
                                defaultValue={_process}
                                placeHolder={intl.formatMessage({ id: 'process' })}
                                options={
                                    termometres_fields
                                        ? termometres_fields.reduce((arr, f) => {
                                              if (
                                                  arr.map((a) => a.value).indexOf(f.proceso) === -1
                                              ) {
                                                  arr.push({ label: f.pnombre, value: f.proceso });
                                              }
                                              return arr;
                                          }, [])
                                        : []
                                }
                                onChange={this.handleChangeProces}
                            />
                        </div>
                    </div>
                    <div className="flex_full_row align_center margin_top_32 margin_bottom_12">
                        <div className={'flex_full width100 barlow_italic c_slate'}>
                            <SelectInput
                                defaultValue={_field}
                                placeHolder={intl.formatMessage({ id: 'field' })}
                                options={
                                    termometres_fields && _process
                                        ? termometres_fields
                                              .filter((f) => f.proceso === _process.value)
                                              .map((f) => {
                                                  return { label: f.cnombre, value: f.campo };
                                              })
                                        : []
                                }
                                onChange={this.handleChangeField}
                            />
                        </div>
                    </div>
                    <div className="flex_full_row align_center margin_top_32">
                        <div className={'barlow_medium_italic c_slate_grey flex_full_row'}>
                            <FormattedMessage id="form_field_name_sensors" />
                        </div>
                        <AddIcon
                            disabled={
                                !(
                                    _process &&
                                    _field &&
                                    fields.map((f) => f.campo).indexOf(_field.value) === -1
                                )
                            }
                            className={
                                _process &&
                                _field &&
                                fields.map((f) => f.campo).indexOf(_field.value) === -1
                                    ? 'c_bluish hand'
                                    : 'c_lipstick hand'
                            }
                            fontSize="large"
                            onClick={this.handleAdd}
                        />
                    </div>
                    <Grid
                        container
                        justify="center"
                        className={'flex_grow_1 align_center termometres_table margin_top_8'}
                    >
                        {fields &&
                            fields.length > 0 &&
                            fields.map((s, i) => {
                                return (
                                    <React.Fragment key={randomstring()}>
                                        <Grid
                                            item
                                            xs={10}
                                            className={
                                                'barlow_regular_textwrap termometres_cell' +
                                                (fields.length === i + 1 ? '_last' : '')
                                            }
                                        >
                                            {s.ncampo}
                                        </Grid>
                                        <Grid
                                            item
                                            xs={1}
                                            className={
                                                'barlow_regular_textwrap margin_right_12 termometres_cell' +
                                                (fields.length === i + 1 ? '_last' : '')
                                            }
                                        >
                                            <DeleteIcon
                                                className={'c_bluish hand'}
                                                onClick={this.handleDelete(s)}
                                            />
                                        </Grid>
                                    </React.Fragment>
                                );
                            })}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose()} color="primary">
                        <FormattedMessage id="cancel" />
                    </Button>
                    <Button
                        disabled={!name || !code || !id}
                        onClick={this.handleClose(name, code, id, fields)}
                        color="primary"
                        autoFocus
                    >
                        <FormattedMessage id="accept" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}
AddSensor.propTypes = {
    intl: intlShape.isRequired,
};

const mapStateToProps = (state) => {
    return {
        termometres_fields: state.termometres_fields,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(injectIntl(AddSensor));



// WEBPACK FOOTER //
// ./src/components/complex/manage/termometre/AddSensor.js